const mapConfig = {
	esriApiKey: getEsriApiKey(),
	arkansasCenter: { longitude: -92.382, latitude: 34.738, zoom: 5.5 },
	smokePlumeRadius: 20 // in miles
}

function getEsriApiKey() {
	return isProductionSite() ? 'AAPK3e03ef34919341d6b6235ae2e35ad44an-aR9-Op_0cGi6smL47JP-IipQhSJ1lbndfDQoQcnbIxha56OwT2IuyppQMGv19B' : 'AAPK1935fcbd251a4fc2a5253eed6553fd26d0HSHNuPFUHU27ST5KJ0047iKHPcvChf45uoqsPyGKcGoDXx8xdW2vhXtHiX_SlO';
}

function isProductionSite() {
	return !window.location.hostname.includes('timmons') && !window.location.hostname.includes('localhost')
}

export default mapConfig;